// react
import React from "react";

export default function BlockMap() {
    return (
        <div className="block-map block">
            <div className="block-map__body">
                {/* <iframe
                    title="Google Map"
                    src="https://maps.google.com/maps?q=Holbrook-Palmer%20Park&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                /> */}

                {/* <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d242.9118051138731!2d80.24650376452858!3d13.061820441987216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267e8dff469a7%3A0x26980d493f615a!2sHogist!5e0!3m2!1sen!2sin!4v1673526227578!5m2!1sen!2sin"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                /> */}
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1374.1255086051638!2d80.24747214649513!3d13.060233113417224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267e8dff469a7%3A0x26980d493f615a!2sHogist%20Technologies%20pvt%20Ltd!5e0!3m2!1sen!2sin!4v1728563221492!5m2!1sen!2sin"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
               />
            </div>
        </div>
    );
}
